module.exports = __webpack_public_path__ + "img/dynamicLogo6.35638ce9.png";